export var commands = {
  logIn: {
    method: 'POST',
    url: 'auth/login/'
  },
  logOut: {
    method: 'POST',
    url: 'auth/logout/'
  },
  getUserInfo: {
    method: 'GET',
    url: 'auth/user/'
  },
  updateOwnPassword: {
    method: 'POST',
    url: 'auth/password/change/'
  },
  resetPassword: {
    method: 'POST',
    url: 'auth/password/change_by_mail/'
  },
  getAllDepartmentsTree: {
    method: 'GET',
    url: 'department/tree/'
  },
  getAllDepartments: {
    method: 'GET',
    url: 'department/'
  },
  getDepartmentInfo: {
    method: 'GET',
    url: 'department/:id/'
  },
  updateDepartment: {
    method: 'PUT',
    url: 'department/:id/'
  },
  createDepartment: {
    method: 'POST',
    url: 'department/'
  },
  getTimetableTemplate: {
    method: 'GET',
    url: 'shop_settings/'
  },
  updateTimetableTemplate: {
    method: 'PUT',
    url: 'shop_settings/:id/'
  },
  createTimetableTemplate: {
    method: 'POST',
    url: 'shop_settings/'
  },
  getWorkTypeName: {
    method: 'GET',
    url: 'work_type_name/'
  },
  updateWorkTypeName: {
    method: 'PUT',
    url: 'work_type_name/:id/'
  },
  createWorkTypeName: {
    method: 'POST',
    url: 'work_type_name/'
  },
  getOperationTypeName: {
    method: 'GET',
    url: 'operation_type_name/'
  },
  updateOperationTypeName: {
    method: 'PUT',
    url: 'operation_type_name/:id/'
  },
  createOperationTypeName: {
    method: 'POST',
    url: 'operation_type_name/'
  },
  getPosition: {
    method: 'GET',
    url: 'worker_position/'
  },
  updatePosition: {
    method: 'PUT',
    url: 'worker_position/:id/'
  },
  createPosition: {
    method: 'POST',
    url: 'worker_position/'
  },
  getOutsourceTree: {
    method: 'GET',
    url: 'department/outsource_tree/'
  },
  getInternalTree: {
    method: 'GET',
    url: 'department/internal_tree/'
  },
  getVacancies: {
    method: 'GET',
    url: 'worker_day/vacancy/'
  },
  confirmVacancy: {
    method: 'POST',
    url: 'worker_day/:id/confirm_vacancy/'
  },
  confirmVacancyToWorker: {
    method: 'POST',
    url: 'worker_day/:id/confirm_vacancy_to_worker/'
  },
  reconfirmVacancyToWorker: {
    method: 'POST',
    url: 'worker_day/:id/reconfirm_vacancy_to_worker/'
  },
  approveVacancy: {
    method: 'POST',
    url: 'worker_day/:id/approve_vacancy/'
  },
  getEditableVacancyId: {
    method: 'GET',
    url: 'worker_day/:id/editable_vacancy/'
  },
  refuseVacancy: {
    method: 'POST',
    url: 'worker_day/:vacancy_id/refuse_vacancy/'
  },
  getAccessGroup: {
    method: 'GET',
    url: 'group/'
  },
  getFunctionGroup: {
    method: 'GET',
    url: 'function_group/'
  },
  createAccessGroup: {
    method: 'POST',
    url: 'group/'
  },
  updateAccessGroup: {
    method: 'PUT',
    url: 'group/'
  },
  getForecastChartData: {
    method: 'GET',
    url: 'timeserie_value/'
  },
  startAutoscheduling: {
    method: 'POST',
    url: 'auto_settings/create_timetable/'
  },
  deleteTimetable: {
    method: 'POST',
    url: 'auto_settings/delete_timetable/'
  },
  getAutoschedulingStatus: {
    method: 'GET',
    url: 'shop_month_stat/status/'
  },
  updateEmploymentAutoTimetable: {
    method: 'POST',
    url: 'employment/auto_timetable/',
    serializer: 'JSON'
  },
  getTickpoint: {
    method: 'GET',
    url: 'recognition/tick_points/'
  },
  updateTickpoint: {
    method: 'PUT',
    url: 'recognition/tick_points/:id/'
  },
  createTickpoint: {
    method: 'POST',
    url: 'recognition/tick_points/'
  },
  deleteTickpoint: {
    method: 'DELETE',
    url: 'recognition/tick_points/:id/'
  },
  getTasks: {
    method: 'GET',
    url: 'task/'
  },
  getRegions: {
    method: 'GET',
    url: 'region/'
  },
  getLoadTemplate: {
    method: 'GET',
    url: 'load_template/'
  },
  createLoadTemplate: {
    method: 'POST',
    url: 'load_template/'
  },
  createLoadTemplateWithFile: {
    method: 'POST',
    url: 'load_template/upload/'
  },
  updateLoadTemplate: {
    method: 'PUT',
    url: 'load_template/:id/'
  },
  loadTemplateDownload: {
    method: 'GET',
    url: 'load_template/:id/download/'
  },
  loadTemplateApply: {
    method: 'POST',
    url: 'load_template/apply/'
  },
  getOperationTypeTemplate: {
    method: 'GET',
    url: 'operation_type_template/'
  },
  deleteOperationTypeTemplate: {
    method: 'DELETE',
    url: 'operation_type_template/:id/'
  },
  createOperationTypeTemplate: {
    method: 'POST',
    url: 'operation_type_template/'
  },
  updateOperationTypeTemplate: {
    method: 'PUT',
    url: 'operation_type_template/:id/'
  },
  getOperationTypeRelation: {
    method: 'GET',
    url: 'operation_type_relation/'
  },
  createOperationTypeRelation: {
    method: 'POST',
    url: 'operation_type_relation/'
  },
  updateOperationTypeRelation: {
    method: 'PUT',
    url: 'operation_type_relation/:id/'
  },
  deleteOperationTypeRelation: {
    method: 'DELETE',
    url: 'operation_type_relation/:id/'
  },
  getAllowedFunctions: {
    method: 'GET',
    url: 'auth/allowed_functions/'
  },
  getWorkerDayPermissions: {
    method: 'GET',
    url: 'worker_day_permissions/'
  },
  getWorkerDay: {
    method: 'GET',
    url: 'worker_day/'
  },
  getDayTypes: {
    method: 'GET',
    url: 'worker_day_type/'
  },
  getTimesheet: {
    method: 'GET',
    url: 'timesheet/'
  },
  recalcWorkingHours: {
    method: 'POST',
    url: 'worker_day/recalc/',
    serializer: 'JSON'
  },
  recalcTimesheet: {
    method: 'POST',
    url: 'timesheet/recalc/',
    serializer: 'JSON'
  },
  getAttendanceRecords: {
    method: 'GET',
    url: 'attendance_records/'
  },
  createWorkerDay: {
    method: 'POST',
    url: 'worker_day/',
    serializer: 'JSON'
  },
  updateWorkerDay: {
    method: 'PUT',
    url: 'worker_day/:id/',
    serializer: 'JSON'
  },
  batchUpdateOrCreateWorkerDay: {
    method: 'POST',
    url: 'worker_day/batch_update_or_create/',
    serializer: 'JSON'
  },
  createDaysForMonth: {
    method: 'POST',
    url: 'worker_day/change_list/',
    serializer: 'JSON'
  },
  deleteWorkerDay: {
    method: 'DELETE',
    url: 'worker_day/:id/'
  },
  duplicateWorkerDays: {
    method: 'POST',
    url: 'worker_day/duplicate/',
    serializer: 'JSON'
  },
  getWorkerInfo: {
    method: 'GET',
    url: 'user/'
  },
  getUsers: {
    method: 'GET',
    url: 'user/'
  },
  addUser: {
    method: 'POST',
    url: 'user/'
  },
  updateUser: {
    method: 'PUT',
    url: 'user/:id/'
  },
  changeUserPassword: {
    method: 'POST',
    url: 'user/:id/change_password/'
  },
  addUserBiometric: {
    method: 'POST',
    url: 'user/:id/add_biometrics/'
  },
  deleteUserBiometric: {
    method: 'POST',
    url: 'user/:id/delete_biometrics/'
  },
  getEmployments: {
    method: 'GET',
    url: 'employment/',
    serializer: 'JSON'
  },
  getEmployees: {
    method: 'GET',
    url: 'employee/'
  },
  createEmployee: {
    method: 'POST',
    url: 'employee/'
  },
  updateEmployee: {
    method: 'PUT',
    url: 'employee/:id/'
  },
  createEmployment: {
    method: 'POST',
    url: 'employment/',
    serializer: 'JSON'
  },
  updateEmployment: {
    method: 'PUT',
    url: 'employment/:id/',
    serializer: 'JSON'
  },
  getGroups: {
    method: 'GET',
    url: 'group/'
  },
  getWorkTypes: {
    method: 'GET',
    url: 'work_type/'
  },
  workTypesUpdate: {
    method: 'PUT',
    url: 'work_type/:id/',
    serializer: 'JSON'
  },
  getAllWorkerPositions: {
    method: 'GET',
    url: 'worker_position/'
  },
  getAllWorkTypes: {
    method: 'GET',
    url: 'worker_work_type/'
  },
  updateEmploymentWorktype: {
    method: 'PUT',
    url: 'employment_work_type/:id/'
  },
  createEmploymentWorktype: {
    method: 'POST',
    url: 'employment_work_type/'
  },
  deleteEmploymentWorktype: {
    method: 'DELETE',
    url: 'employment_work_type/:id/'
  },
  saveEmploymentConstraints: {
    method: 'POST',
    url: 'employment/:id/worker_constraint/',
    serializer: 'JSON'
  },
  approveWorkerDays: {
    method: 'POST',
    url: 'worker_day/approve/',
    serializer: 'JSON'
  },
  requestApproveWorkerDays: {
    method: 'POST',
    url: 'worker_day/request_approve/',
    serializer: 'JSON'
  },
  getWorkerStats: {
    method: 'GET',
    url: 'worker_day/worker_stat/'
  },
  updateBlockWorkerDays: {
    method: 'POST',
    url: 'worker_day/batch_block_or_unblock/',
    serializer: 'JSON'
  },
  getTimesheetStats: {
    method: 'GET',
    url: 'timesheet/stats/'
  },
  getDailyStats: {
    method: 'GET',
    url: 'worker_day/daily_stat/'
  },
  getCoverageChartsData: {
    method: 'GET',
    url: 'work_type/efficiency/'
  },
  getOperationTypes: {
    method: 'GET',
    url: 'operation_type/'
  },
  uploadSchedule: {
    method: 'POST',
    url: 'worker_day/upload/'
  },
  uploadFactSchedule: {
    method: 'POST',
    url: 'worker_day/upload_fact/'
  },
  uploadWorkload: {
    method: 'POST',
    url: 'timeserie_value/upload/'
  },
  getMetabaseUrl: {
    method: 'GET',
    url: 'metabase_url/'
  },
  calculateTemplate: {
    method: 'POST',
    url: 'load_template/calculate/'
  },
  getDepartmentSchedule: {
    method: 'GET',
    url: 'department/:id/schedule/'
  },
  updateDepartmentSchedule: {
    method: 'PUT',
    url: 'department/:id/schedule/:date/'
  },
  updateDepLoadTemplate: {
    method: 'PUT',
    url: 'department/:id/load_template/'
  },
  deleteWorkerDays: {
    method: 'POST',
    url: 'worker_day/delete_worker_days/',
    serializer: 'JSON'
  },
  exchangeWorkerDays: {
    method: 'POST',
    url: 'worker_day/exchange/',
    serializer: 'JSON'
  },
  copyApprovedWorkerDays: {
    method: 'POST',
    url: 'worker_day/copy_approved/',
    serializer: 'JSON'
  },
  copyPasteWorkerDaysForMonth: {
    method: 'POST',
    url: 'worker_day/copy_range/',
    serializer: 'JSON'
  },
  getContentBlock: {
    method: 'GET',
    url: 'content_block/',
    serializer: 'JSON'
  },
  getTimesheetItems: {
    method: 'GET',
    url: 'timesheet/items/',
    serializer: 'JSON'
  },
  getEmployeeShiftSchedule: {
    method: 'GET',
    url: 'employee/shift_schedule/',
    serializer: 'JSON'
  },
  getPBIInfo: {
    method: 'GET',
    url: 'pbi/get_embed_info/',
    serializer: 'JSON'
  },
  getNetworks: {
    method: 'GET',
    url: 'network/',
    serializer: 'JSON'
  },
  getMedicalDocumentTypes: {
    method: 'GET',
    url: 'medical_document_type/',
    serializer: 'JSON'
  },
  addMedicalDocumentType: {
    method: 'POST',
    url: 'medical_document_type/'
  },
  updateMedicalDocumentType: {
    method: 'PUT',
    url: 'medical_document_type/:id/'
  },
  deleteMedicalDocumentType: {
    method: 'DELETE',
    url: 'medical_document_type/:id/'
  },
  getMedicalDocuments: {
    method: 'GET',
    url: 'medical_document/',
    serializer: 'JSON'
  },
  addMedicalDocument: {
    method: 'POST',
    url: 'medical_document/'
  },
  updateMedicalDocument: {
    method: 'PUT',
    url: 'medical_document/:id/'
  },
  deleteMedicalDocument: {
    method: 'DELETE',
    url: 'medical_document/:id/'
  },
  getTickReport: {
    method: 'GET',
    url: 'report/tick/',
    serializer: 'QueryWithArray'
  },
  getScheduleDeviationReport: {
    method: 'GET',
    url: 'report/schedule_deviation/',
    serializer: 'QueryWithArray'
  },
  getIPAddressList: {
    method: 'GET',
    url: 'recognition/shop_ip_address/',
    serializer: 'JSON'
  },
  addIPAddress: {
    method: 'POST',
    url: 'recognition/shop_ip_address/'
  },
  deleteIPAddress: {
    method: 'DELETE',
    url: 'recognition/shop_ip_address/:id/'
  }
};